import { useMutation } from 'react-query';

import { request } from '../../request';

export const useLogin = () => {
  return useMutation((data: { id: string; signature: string; token?: string; chain_id: string }) =>
    request.post<{ session_id: string }>('/user/login_v2', data),
  );
};
